import { useLanguage } from '@/i18n/LanguageContext'
import { Badge } from '@/components/ui/badge'
import { useFbProfiles } from '@/api/hooks/useExtension'
import { Clock, RefreshCw, CheckCircle, AlertCircle, X, Check } from 'lucide-react'

export function ProfileFilter({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const { t } = useLanguage()
  const { data } = useFbProfiles()

  return (
    <div className="flex gap-1.5 flex-wrap">
      <Badge variant={!value ? 'default' : 'outline'} className="cursor-pointer rounded-lg transition-all duration-200 hover:shadow-sm" onClick={() => onChange('')}>
        {t('Todos Perfis')}
      </Badge>
      {data?.profiles.map(p => (
        <Badge key={p.id} variant={value === p.id ? 'default' : 'outline'} className="cursor-pointer rounded-lg border-border/40 transition-all duration-200 hover:shadow-sm" onClick={() => onChange(value === p.id ? '' : p.id)}>
          <span className={`w-2 h-2 rounded-full mr-1.5 ${p.isOnline ? 'bg-green-500' : 'bg-zinc-500'}`} />
          {p.name}
        </Badge>
      ))}
    </div>
  )
}

export function statusBadge(status: string) {
  const map: Record<string, { variant: 'default' | 'secondary' | 'destructive' | 'outline'; icon: typeof Check }> = {
    pending: { variant: 'outline', icon: Clock },
    processing: { variant: 'default', icon: RefreshCw },
    done: { variant: 'secondary', icon: CheckCircle },
    failed: { variant: 'destructive', icon: AlertCircle },
    cancelled: { variant: 'outline', icon: X },
    success: { variant: 'secondary', icon: Check },
  }
  const m = map[status] || map.pending
  const Icon = m.icon
  return <Badge variant={m.variant} className="rounded-md text-[10px]"><Icon className={`h-3 w-3 mr-1 ${status === 'processing' ? 'animate-spin' : ''}`} />{status}</Badge>
}

export function timeAgo(ts: number | null, t: (s: string) => string) {
  if (!ts) return t('Nunca')
  const diff = Math.floor((Date.now() - ts) / 1000)
  if (diff < 60) return t('Agora')
  if (diff < 3600) return `${Math.floor(diff / 60)}min`
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`
  return `${Math.floor(diff / 86400)}d`
}
